/**
 * Route for `affiliate-notes`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AffiliateNotesPage } from "../features/affiliate-notes/AffiliateNotesPage";

export const affiliateNotesRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/affiliate-notes",
	component: AffiliateNotesPage,
});

export default affiliateNotesRoute;
